import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id?: string;
  label?: string;
};

export const useVehicleTypeSet = () => {
  const [vehicleTypeSetLoading, setVehicleTypeSetLoading] =
    useState(false);
  const [vehicleTypeSet, setVehicleTypeSet] = useState([]);

  const getVehicleTypeSet = useCallback(async (params: TParams) => {
    setVehicleTypeSetLoading(true);
    const res = await request({
      path: "vehicle-Type/set",
      method: "POST",
      body: JSON.stringify(params),
    });
    setVehicleTypeSet(res?.data);
    setVehicleTypeSetLoading(false);
    return res?.data;
  }, []);

  return { vehicleTypeSetLoading, vehicleTypeSet, getVehicleTypeSet };
};
